var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246.65,
    height: 39.408,
    viewBox: "0 0 246.65 39.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.137,
    y1: 0.045,
    x2: 0.841,
    y2: 1.032,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696",
    transform: "translate(-5181 -3954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-star",
    d: "M24.913,5.186l5.478,12.288,13.378,1.413a1,1,0,0,1,.564,1.737l-9.993,9L37.131,42.79a1,1,0,0,1-1.478,1.074L24,37.141,12.347,43.863a1,1,0,0,1-1.478-1.074L13.66,29.628,3.667,20.623a1,1,0,0,1,.564-1.737l13.378-1.413L23.087,5.185A1,1,0,0,1,24.913,5.186Z",
    transform: "translate(5177.665 3949.407)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-star-2",
    "data-name": "icons8-star",
    d: "M24.913,5.186l5.478,12.288,13.378,1.413a1,1,0,0,1,.564,1.737l-9.993,9L37.131,42.79a1,1,0,0,1-1.478,1.074L24,37.141,12.347,43.863a1,1,0,0,1-1.478-1.074L13.66,29.628,3.667,20.623a1,1,0,0,1,.564-1.737l13.378-1.413L23.087,5.185A1,1,0,0,1,24.913,5.186Z",
    transform: "translate(5228.995 3949.407)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-star-3",
    "data-name": "icons8-star",
    d: "M24.913,5.186l5.478,12.288,13.378,1.413a1,1,0,0,1,.564,1.737l-9.993,9L37.131,42.79a1,1,0,0,1-1.478,1.074L24,37.141,12.347,43.863a1,1,0,0,1-1.478-1.074L13.66,29.628,3.667,20.623a1,1,0,0,1,.564-1.737l13.378-1.413L23.087,5.185A1,1,0,0,1,24.913,5.186Z",
    transform: "translate(5280.325 3949.407)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-star-4",
    "data-name": "icons8-star",
    d: "M24.913,5.186l5.478,12.288,13.378,1.413a1,1,0,0,1,.564,1.737l-9.993,9L37.131,42.79a1,1,0,0,1-1.478,1.074L24,37.141,12.347,43.863a1,1,0,0,1-1.478-1.074L13.66,29.628,3.667,20.623a1,1,0,0,1,.564-1.737l13.378-1.413L23.087,5.185A1,1,0,0,1,24.913,5.186Z",
    transform: "translate(5331.655 3949.407)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-star-5",
    "data-name": "icons8-star",
    d: "M24.913,5.186l5.478,12.288,13.378,1.413a1,1,0,0,1,.564,1.737l-9.993,9L37.131,42.79a1,1,0,0,1-1.478,1.074L24,37.141,12.347,43.863a1,1,0,0,1-1.478-1.074L13.66,29.628,3.667,20.623a1,1,0,0,1,.564-1.737l13.378-1.413L23.087,5.185A1,1,0,0,1,24.913,5.186Z",
    transform: "translate(5382.985 3949.407)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.975c016cc6d2243b42afb039005112cf.svg";
export { ForwardRef as ReactComponent };